module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section01_02_beach-photo-d653bb885ba7a037ffacae9e7ddcaf3f.jpg";